import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaKey } from "react-icons/fa";

import {
    FaCamera,
    FaVideo,
    FaImages,
    FaBoxOpen,
    FaComments,
    FaEnvelope,
    FaCloudUploadAlt,
    FaUserShield,
    FaArrowUp
} from "react-icons/fa";

import "../assets/css/admin/adminDashboard.css";


import { db } from "../firebase/firebase";

import {
    collection,
    getDocs
} from "firebase/firestore";

function AdminDashboard() {

    const navigate = useNavigate();

    /* ==========================================
            STATES
    ========================================== */

    const [photos, setPhotos] = useState([]);

    const [videos, setVideos] = useState([]);
      const [packages, setPackages] = useState([]);
      const [feedbacks, setFeedbacks] = useState([]);
      const [contacts, setContacts] = useState([]);


    const [todayUploads, setTodayUploads] = useState(0);

    const [weekUploads, setWeekUploads] = useState(0);

    const [monthUploads, setMonthUploads] = useState(0);

    const [categoryCount, setCategoryCount] = useState({});
     const [galleryCategories, setGalleryCategories] = useState([]);
    
    
    
     

    /* ==========================================
            LOAD
    ========================================== */

    useEffect(() => {

        loadDashboard();

    }, []);

    /* ==========================================
            LOAD FIRESTORE
    ========================================== */

    const loadDashboard = async () => {

        const photoSnap =
            await getDocs(collection(db,"photos"));

        const videoSnap =
            await getDocs(collection(db,"videos"));
        const packageSnap =
            await getDocs(collection(db, "packages"));

        const feedbackSnap =
            await getDocs(collection(db, "feedbacks"));

              const contactSnap =
            await getDocs(collection(db, "contacts"));

        let photoList = [];

        let videoList = [];

        let today = 0;

        let week = 0;

        let month = 0;

        const categorySnap = await getDocs(
    collection(db, "gallery_categories")
);

const categoryList = [];
const categories = {};

categorySnap.forEach((doc) => {

    const data = doc.data();

    categoryList.push({
        id: doc.id,
        ...data
    });

    categories[data.title] = 0;

});

setGalleryCategories(categoryList);

        const now = new Date();

        const processDocs = (snapshot,type) => {

            snapshot.forEach((doc)=>{

                const item = {

                    id:doc.id,

                    type,

                    ...doc.data()

                };

                if(type==="photo"){

                    photoList.push(item);

                }

                else{

                    videoList.push(item);

                }

              if (item.category && categories.hasOwnProperty(item.category)) {

    categories[item.category]++;

}

                if(item.createdAt){

                    const uploadDate =
                        item.createdAt.toDate();

                    const diffDays =
                        Math.floor(

                            (now-uploadDate)

                            /

                            (1000*60*60*24)

                        );

                    if(diffDays===0){

                        today++;

                    }

                    if(diffDays<=7){

                        week++;

                    }

                    if(

                        uploadDate.getMonth()===now.getMonth()

                        &&

                        uploadDate.getFullYear()===now.getFullYear()

                    ){

                        month++;

                    }

                }

            });

        };

        processDocs(photoSnap,"photo");

        processDocs(videoSnap,"video");
        console.log(categories);

        setPhotos(photoList);

        setVideos(videoList);

        setPackages(
    packageSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }))
);

             setFeedbacks(
    feedbackSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }))
);
          setContacts(
    contactSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }))
);

        setTodayUploads(today);

        setWeekUploads(week);

        setMonthUploads(month);

        setCategoryCount(categories);

    };
        return (

        <>

            <div className="dashboard-container">
 
                <main className="dashboard-main">

                    {/* ======================================
                            HEADER
                    ====================================== */}

                    <div className="dashboard-header">

                        <div>

                            <h1>
                                Welcome Back 👋
                            </h1>

                            <p>
                                Manage your Story Line Studios from one premium dashboard.
                            </p>

                        </div>

                        <div className="admin-profile">

                            <div className="profile-image">

                                <FaUserShield />

                            </div>

                            <div>

                                <h3>Administrator</h3>

                                <span>Story Line Studios</span>

                            </div>

                        </div>

                    </div>

                    {/* ======================================
                            DASHBOARD CARDS
                    ====================================== */}

                    <div className="card-container">

                        <div
    className="dashboard-card"
    onClick={() => navigate("/admin/manage-gallery/photos/All")}
>

    <FaCamera className="card-icon" />

    <h3>Total Photos</h3>

    <h2>{photos.length}</h2>

</div>
<div
    className="dashboard-card"
    onClick={() => navigate("/admin/manage-gallery/videos/All")}
>

    <FaVideo className="card-icon" />

    <h3>Total Videos</h3>

    <h2>{videos.length}</h2>

</div>

                        <div
                            className="dashboard-card"
                            onClick={() => navigate("/admin/manage-gallery")}
                        >

                            <FaImages className="card-icon"/>

                            <h3>Gallery Items</h3>

                            <h2>{photos.length + videos.length}</h2>

                        </div>

                        <div
                            className="dashboard-card"
                            onClick={() => navigate("/admin/manage-packages")}
                        >

                            <FaBoxOpen className="card-icon"/>

                            <h3>Packages</h3>

                            <h2>{packages.length}</h2>

                        </div>

                        <div
                            className="dashboard-card"
                            onClick={() => navigate("/admin/feedback")}
                        >

                            <FaComments className="card-icon"/>

                            <h3>Feedback</h3>

                            <h2>{feedbacks.length}</h2>

                        </div>

                        <div
                            className="dashboard-card"
                            onClick={() => navigate("/admin/contact")}
                        >

                            <FaEnvelope className="card-icon"/>

                            <h3>Contacts</h3>

                             <h2>{contacts.length}</h2>

                        </div>

                    </div>

                    {/* ======================================
                            QUICK ACTIONS
                    ====================================== */}

                    <div className="quick-actions">

                        <button
                            onClick={() => navigate("/admin/upload")}
                        >

                            <FaCloudUploadAlt/>

                            Upload Photo

                        </button>

                        <button
                            onClick={() => navigate("/admin/upload-video")}
                        >

                            <FaVideo/>

                            Upload Video

                        </button>

                        <button
                            onClick={() => navigate("/admin/manage-packages")}
                        >

                            <FaBoxOpen/>

                            Packages

                        </button>

                        <button
                            onClick={() => navigate("/admin/homeimage")}
                        >

                            <FaImages/>

                            Home Background

                        </button>
                       <button
    onClick={() => navigate("/admin/change-password")}
>

    <FaKey />

    Change Password

</button>
                    </div>

                    {/* ======================================
                            STATISTICS
                    ====================================== */}

                    <div className="stats-section">
                                                 {/* ==============================
                                CATEGORY SECTION
                        ============================== */}

   <div className="stats-box">

    <h2>Gallery Categories</h2>

    <div className="category-grid">

        {galleryCategories.map((category) => (

          <div
    className="category-card"
    key={category.id}
   onClick={() =>
    navigate(`/admin/manage-gallery/${encodeURIComponent(category.title)}`)
}
    style={{ cursor: "pointer" }}
>

                <img
                    src={category.coverImage}
                    alt={category.title}
                    className="category-cover"
                />

                <h4>{category.title}</h4>

                <h3>{categoryCount[category.title] || 0}</h3>

            </div>

        ))}

    </div>



                        </div>

                        {/* ==============================
                                UPLOAD STATISTICS
                        ============================== */}

                        <div className="stats-box">

                            <h2>Upload Statistics</h2>

                            <div className="upload-stats">

                                <div className="upload-card">

                                    <FaArrowUp className="upload-icon"/>

                                    <h4>Today</h4>

                                    <h1>{todayUploads}</h1>

                                </div>

                                <div className="upload-card">

                                    <FaArrowUp className="upload-icon"/>

                                    <h4>This Week</h4>

                                    <h1>{weekUploads}</h1>

                                </div>

                                <div className="upload-card">

                                    <FaArrowUp className="upload-icon"/>

                                    <h4>This Month</h4>

                                    <h1>{monthUploads}</h1>

                                </div>

                            </div>

                        </div>

                    </div>

                    {/* ==============================
                            RECENT UPLOADS
                    ============================== */}

                    <div className="recent-section">

                        <div className="section-title">

                            <h2>Recent Uploads</h2>

                            <button
                                className="view-all-btn"
                                onClick={() => navigate("/admin/manage-gallery")}
                            >

                                View All

                            </button>

                        </div>

                        <div className="recent-grid">



                                                    {[...photos, ...videos]
                            .sort((a, b) => {
                                if (!a.createdAt || !b.createdAt) return 0;
                                return b.createdAt.seconds - a.createdAt.seconds;
                            })
                            .slice(0, 6)
                            .map((item) => (

                                <div
                                    className="recent-card"
                                    key={item.id}
                                >

                                    <div className="media-container">

                                        {item.type === "photo" ? (

                                            <img
                                                src={item.imageUrl}
                                                alt={item.title}
                                            />

                                        ) : (

                                            <video controls>

                                                <source
                                                    src={item.videoUrl}
                                                />

                                            </video>

                                        )}

                                    </div>

                                    <div className="recent-content">

                                        <span className="media-type">

                                            {item.type === "photo"
                                                ? "📷 Photo"
                                                : "🎥 Video"}

                                        </span>

                                        <h3>

                                            {item.title || "Untitled"}

                                        </h3>

                                        <p>

                                            {item.category}

                                        </p>

                                    </div>

                                </div>

                            ))}

                        {photos.length + videos.length === 0 && (

                            <div className="empty-dashboard">

                                <FaImages className="empty-icon" />

                                <h2>No Gallery Items</h2>

                                <p>

                                    Start by uploading your first
                                    photo or video.

                                </p>

                                <button

                                    onClick={() =>
                                        navigate("/admin/upload")
                                    }

                                    className="upload-now-btn"

                                >

                                    Upload Now

                                </button>

                            </div>

                        )}

                        </div>

                    </div>

                </main>

            </div>

            

        </>

    );

}

export default AdminDashboard;
        
                  

                    